import Vue from 'vue'

const popExitingConfirmation = () => {
  const $t = Vue.i18n.translate
  return window.confirm($t('geral.perguntas.sairPagina'))
}

export default popExitingConfirmation



// WEBPACK FOOTER //
// ./client/utils/popExitingConfirmation.js